
  import Vue from 'vue'
  import UserList from '@/components/space/UserList.vue'

  export default Vue.extend({
    name: 'SpaceUsersAdministration',
    components: {
      UserList
    },
    created() {
      document.title = this.$vuetify.lang.t("$vuetify.tab_titles.space_users")
    }
  })
